import { useRouteError, useNavigate } from "react-router-dom";
import { ProjectButton } from "./project/style";

function ErrorPage() {
  const error = useRouteError();
  console.error(error);
  const navigate = useNavigate();

  return (
    <div id="error-page">
      <div
        className="d-flex flex-column align-items-center pt-5"
        style={{ gap: "20px" }}
      >
        <h4>{error.data}</h4>
        <ProjectButton
          size="20px !important"
          padding="8px 20px"
          onClick={() => navigate("/")}
        >
          Take me to Home
        </ProjectButton>
      </div>
    </div>
  );
}

export default ErrorPage;
